import ClientDetailApp from "Client/Detail/App";
import ClientListApp from "Client/List/app";
import ClientCreateApp from "Client/New/ClientCreateApp";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const clientRoute: RouteObject = {
  path: "adminone/client",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ClientListApp,
  }, {
    path: "new",
    loader: () => viewModel,
    Component: ClientCreateApp
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: ClientDetailApp,
  }]
};